import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IElementSequenceQuestion} from '../../../../../incase-domain/elements/question/questionSequence';
import {getAnswerStyles} from '../common/getStyles';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';

type SequenceItem = {text: string; comment: string};

interface SequenceQuestionClickOrderProps {
    element: IElementSequenceQuestion;
    markedAnswers: SequenceItem[];
    onChange: (markedAnswers: SequenceItem[]) => void;
    device: DeviceType;
    hostStyled?: boolean;
}

function SequenceQuestionClickOrder(props: SequenceQuestionClickOrderProps): ReactElement {
    const {element, markedAnswers, onChange, device, hostStyled = false} = props;

    const placedTexts = markedAnswers.map((item) => item.text);
    const answerStyles = getAnswerStyles(device, element);

    return (
        <div className={`c-sequenceQuestionClickOrder ${device === DeviceType.MOBILE ? 'c-sequenceQuestionClickOrder--mobile' : ''}`}>
            <div className="c-sequenceQuestionClickOrder__column">
                {element.sequence.map((item, index) => (
                    <QuestionAnswer
                        key={`sequence-option-${element.id}-${index}`}
                        answer={item.text}
                        answerType={AnswerTypes.NONE}
                        correctColor={element.correctColor}
                        incorrectColor={element.incorrectColor}
                        debatableColor={element.debatableColor}
                        hostStyled={hostStyled}
                        styles={answerStyles}
                        disabled={placedTexts.includes(item.text)}
                        onClick={() => onChange([...markedAnswers, item])}
                        device={device}
                        setShowComment={() => undefined}
                    />
                ))}
            </div>
            <div className="c-sequenceQuestionClickOrder__column">
                {element.sequence.map((_, index) => {
                    const item = markedAnswers[index];

                    if (!item) {
                        return (
                            <div key={`sequence-slot-${element.id}-${index}`} className="c-sequenceQuestionClickOrder__slot">
                                <div style={hostStyled ? undefined : answerStyles}>{index + 1}</div>
                            </div>
                        );
                    }

                    return (
                        <QuestionAnswer
                            key={`sequence-placed-${element.id}-${index}`}
                            answer={`${index + 1}. ${item.text}`}
                            answerType={AnswerTypes.SELECTED}
                            hostStyled={hostStyled}
                            styles={answerStyles}
                            onClick={() => onChange(markedAnswers.filter((_, itemIndex) => itemIndex !== index))}
                            device={device}
                            setShowComment={() => undefined}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default SequenceQuestionClickOrder;
